/**
 * ProducersList Presentational Component
 * For more informations about this kind of component, read README
 *
 * References:
 *  - https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
 */

import React, { useState } from 'react';
import {
  FiChevronUp, FiChevronDown,
} from 'react-icons/fi';
import ReactTooltip from 'react-tooltip';

import styles from './ProducersList.module.css';
import { Image } from '../../../../components';

/**
 * useFloatingList UI logic hook.
 * Enable eventsHandlres to control UI behaviour and localStates to represent UI states.
 * @param {Commands} commands
 * @returns local states and events handles
 */
export function useProducersList(commands) {
  const [opened, setOpened] = useState(false);

  const handleOpenList = () => {
    commands.closePopup();
    setOpened(true)
  };
  const handleCloseList = () => setOpened(false);
  const handleItemClick = (latlng) => {
    commands.moveToLocation(latlng);
    setOpened(false);
  };

  return {
    localStates: { opened },
    eventsHandlers: {
      handleOpenList,
      handleCloseList,
      handleItemClick,
    },
  };
}

/**
 * FloatingList purely presentational component
 * Get user events and pass it to UI hook
 * @returns JSX presentational component
 */
export default function ProucersList(props) {
  const { sharedStates, commands } = props;
  const { localStates, eventsHandlers } = useProducersList(commands);

  return (
    <div className={styles.container}>
      { 
        sharedStates.geoPermissionStatus === 'denied'
          ? (
            <>
              <span 
                onClick={() => { ReactTooltip.show() }}
                className={styles['approximate-location']}
                data-tip
                data-for="approximate-location"
              >
                Localização aproximada,
                <span className={styles['mobile-text']}> clique para saber mais</span>
                <span className={styles['desktop-text']}> passe o cursor saber mais</span>
              </span>

              <ReactTooltip
                type="light"
                id="approximate-location"
                place="top"
                effect="solid"
                multiline
                className={styles.tooltip}
              >
                O acesso à sua localização está bloqueado.
                Caso queira ter uma experiência de navegação mais completa,
                permita o uso da sua localização em seu navegador ou sistema operacional.
              </ReactTooltip>
            </>
          )
          : (<></>)
      }
      
      <div className={styles.content}>
        <section 
          className={styles.header}
          onClick={localStates.opened ? eventsHandlers.handleCloseList :  eventsHandlers.handleOpenList}
        >
          <div className={styles['search-box-container']}>
            <p className={styles['search-box']}>
              Espaços por perto
            </p>
          </div>

          {localStates.opened
            ? <FiChevronDown className={styles['header-icon']} size={32} strokeWidth="2" color="#999" />
            : <FiChevronUp className={styles['header-icon']} size={32} strokeWidth="2" color="#999" />}
        </section>

        <section className={localStates.opened ? styles['items-opened'] : styles.items}>
          {
            localStates.opened && sharedStates.addressesSortedByDistance?.filter((address) => {
              const producerHasImages = address.producer.imagesPaths?.length;
              // const producerHasOffers = sharedStates.offers?.find((offer) => offer.producerId === producer.id);

              return producerHasImages;
            })
            .map((address, index) => (
              <div
                key={address.id}
                onClick={() => eventsHandlers.handleItemClick([address.lat, address.lng])}
                className={styles['item-container']}
                role="button"
              >
                <section className={styles['item-image']}>
                  <Image
                    src={address.producer?.imagesPaths.length ? address.producer.imagesPaths[address.producer.imagesPaths.length - 1] : ''}
                    alt={address.producer?.name}
                    rounded
                  />
                  <p>
                    {Intl.NumberFormat('pt-BR', { maximumSignificantDigits: 2 }).format(address.distance)}
                    {' km'}
                  </p>
                </section>

                <section className={styles['producer-info']}>
                  <h1>{`@${address.producer?.nickname}`}</h1>
                  <h2>{address.producer?.name}</h2>
                  <p>{`${address.city} - ${address.uf}`}</p>
                  <p>{address.neighborhood}</p>
                </section>
              </div>
            ))}
        </section>
      </div>
    </div>
  );
}
